<template>
  <div>
    <div class="card p-3 shadow-sm">
      <form @submit.prevent="" class="w-100">
        <div class="row" v-if="(user.id === selectedAuditRecord.created_by_id || isAllowed('vessel-ia.appointment.appointment.edit-details')) || isAllowed('vessel-ia.appointment.appointment.edit-voyage-only')">
          <div class="col-12 text-right" v-if="user.is_vessel === false && isAllowed('vessel-ia.appointment.appointment.edit-details')">
            <template v-if="toEdit" >
              <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancel">Cancel
              </button>
              <button class="e-btn e-btn-blue ml-2" type="submit" @click="submit" :class="hasChanges === false ? 'e-btn-blue-disabled' : ''" :disabled="hasChanges === false">Save</button>
            </template>
            <button class="e-btn e-btn-green ml-2" type="button" v-else @click="editDetails">Edit Appointment Details</button>

          </div>
          <div class="col-12 text-right" v-else-if="isAllowed('vessel-ia.appointment.appointment.edit-voyage-only')">
            <template v-if="user.is_vessel === true && isOwnVessel('vesselAuditRecord')">
              <template v-if="toEditVoyageData" >
                <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelVoyage">Cancel
                </button>
                <button class="e-btn e-btn-blue ml-2" type="submit" @click="submit" :class="hasVoyageDataChanges === false ? 'e-btn-blue-disabled' : ''" :disabled="hasVoyageDataChanges === false">Save</button>
              </template>
              <button class="e-btn e-btn-green mr-3" type="button" v-else @click="editVoyageData">Edit Voyage Data</button>
            </template>
            <template v-if="user.is_vessel === false">
              <template v-if="toEditVoyageData" >
                <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelVoyage">Cancel
                </button>
                <button class="e-btn e-btn-blue ml-2" type="submit" @click="submit" :class="hasVoyageDataChanges === false ? 'e-btn-blue-disabled' : ''" :disabled="hasVoyageDataChanges === false">Save</button>
              </template>
              <button class="e-btn e-btn-green mr-3" type="button" v-else @click="editVoyageData">Edit Voyage Data</button>
            </template>
          </div>
        </div>

        <div class="mb-4">
          <h6 class="h6">Appointment Details</h6>
          <table class="w-100">
            <tr v-if="toEdit">
              <td style="width: 25%;">Plan Remarks</td>
              <td style="width: 100%;">
                <vue-editor v-model="planRemarks" class="my-2" :editor-toolbar="toolbar">
                </vue-editor>
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>
            <tr v-else>
              <td style="width: 25%;">Plan Remarks</td>
              <td style="width: 100%;">
                <display-mode-vue-editor
                  :html-content="ia_appointment_details.plan_remarks ?? ''"
                />
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>
            <template v-if="selectedAuditRecord[$route.params.type].audit_type_3[0] === 2">
              <tr v-if="toEdit">
                <td style="width: 25%;">Reason for the Remote Audit <sub class="lead e-text-red font-weight-bold">*</sub></td>
                <td style="width: 100%;">
                  <vue-editor v-model="remoteAuditReason" class="my-2" :editor-toolbar="toolbar">
                  </vue-editor>
                </td>
                <td style="width: 12%;"></td>
                <td></td>
              </tr>
              <tr v-else>
                <td style="width: 25%;">Reason for the Remote Audit <sub class="lead e-text-red font-weight-bold">*</sub></td>
                <td style="width: 100%;">
                  <display-mode-vue-editor
                    :html-content="ia_appointment_details.remote_audit_reason ?? ''"
                  />
                </td>
                <td style="width: 12%;"></td>
                <td></td>
              </tr>
            </template>
            <tr v-if="toEdit">
              <td style="width: 25%;">Appointment / Approved By</td>
              <td style="width: 100%;">
                <select name="" id="" class="form-control form-control-sm" v-model="auditorID">
                  <option  :value="null" selected disabled v-if="this.$route.params.type === 'sms'">-- SELECT DIRECTOR OF SHIP MANAGEMENT OFFICE --</option>
                  <option  :value="null" selected disabled v-if="this.$route.params.type === 'isps'">-- SELECT COMPANY SECURITY OFFICER --</option>
                  <option  :value="null" selected disabled v-if="this.$route.params.type === 'cyber'">-- SELECT COMPANY CYBER SECURITY OFFICER --</option>
                  <option v-for="auditor in designated_persons[this.$route.params.type]" :key="auditor.id" :value="auditor.id">
                    {{ auditor.fullname.toUpperCase() }}
                  </option>
                </select>
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>
            <tr v-else>
              <td style="width: 25%;">Appointment / Approved By</td>
              <td style="width: 100%;">
                {{ ia_appointment_details?.auditor?.name.toUpperCase() }}
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>

            <tr v-if="toEdit || toEditAuditDone">
              <td style="width: 25%;">Audit Done <sub class="lead e-text-red font-weight-bold">*</sub></td>
              <td style="width: 100%; display: flex; align-items: center; justify-content: space-between;">
                <select name="" id="" class="form-control form-control-sm" v-model="isAuditDone" style="width: auto; flex-grow: 1;">
                  <option :value="0">NOT IMPLEMENTED</option>
                  <option :value="1">DONE</option>
                </select>

                <template v-if="toEditAuditDone">
                  <div class="float-right" style="white-space: nowrap;">
                    <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelEditAuditDone">Cancel
                    </button>
                    <button class="e-btn e-btn-blue ml-2" type="submit" @click="submit" :class="hasAuditDoneChanges === false ? 'e-btn-blue-disabled' : ''" :disabled="hasAuditDoneChanges === false">Save</button>
                  </div>
                </template>
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>
            <tr v-else>
              <td style="width: 25%;">Audit Done <sub class="lead e-text-red font-weight-bold">*</sub></td>
              <td style="width: 100%;">
                {{ ia_appointment_details?.is_audit_done === 1 ? 'DONE' : 'NOT IMPLEMENTED' }}
                <button
                  v-if="isAllowed('vessel-ia.appointment.appointment.edit-details') === false && is_auditor === true"
                  class="e-btn e-btn-green ml-2 float-right"
                  type="button"
                  @click="editAuditDone"
                >
                  Edit Audit Done
                </button>
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>

            <tr v-if="toEdit || toEditVoyageData">
              <td style="width: 25%;">Voyage Data</td>
              <td v-if="isAllowed('vessel-ia.appointment.appointment.edit-voyage-only') || toEditVoyageData" style="width: 100%;">
                <vue-editor v-model="voyageData" class="my-2" :editor-toolbar="toolbar">
                </vue-editor>
              </td>
              <td v-else>
                <display-mode-vue-editor
                  :html-content="ia_appointment_details.voyage_data ?? ''"
                />
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>
            <tr v-else>
              <td style="width: 25%;">Voyage Data</td>
              <td style="width: 100%;">
                <display-mode-vue-editor
                  :html-content="ia_appointment_details.voyage_data ?? ''"
                />
              </td>
              <td style="width: 12%;"></td>
              <td></td>
            </tr>
          </table>
        </div>
      </form>
    </div>
    <internal-audit-report
      style="display: none"
    />
  </div>
</template>

<script>

import AuditRecordMixin from "@/mixins/AuditRecordMixin";
import {AlertService} from "@/services/AlertService";
import {mapActions, mapGetters} from "vuex";
import {DataService} from "@/services/DataService";
import DisplayModeVueEditor from "@/components/common/DisplayModeVueEditor.vue";
import InternalAuditReport from "@/components/modules/ia/vessel/InternalAuditReport.vue";
import {UserService} from "@/services/UserService";

export default {
  name: 'AppointmentDetails',
  components: {InternalAuditReport, DisplayModeVueEditor},
  mixins: [
    AuditRecordMixin
  ],
  data() {
    return {
      toEdit : false,
      toEditVoyageData: false,
      toEditAuditDone : false,
      planRemarks : '',
      auditorID: null,
      isAuditDone : 0,
      voyageData: '',
      remoteAuditReason : '',
      is_auditor : false,
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]
        }]
      ],
    }
  },
  methods: {
    ...mapActions([
      'updateAppointmentDetails',
      'getAppointmentDetailsByTypeAndId',
      'getDesignatedPerson'
    ]),
    async cancel() {
      if (this.hasChanges === false) {
        this.toEdit = false;
        return;
      }
      if (await AlertService.cancelAlert()) {
        this.toEdit = false;
      }

    },
    async cancelEditAuditDone() {
      if (this.hasChanges === false) {
        this.toEditAuditDone = false;
        return;
      }
      if (await AlertService.cancelAlert()) {
        this.toEditAuditDone = false;
      }
    },
    async cancelVoyage() {
      if (this.hasChanges === false) {
        this.toEditVoyageData = false;
        return;
      }
      if (await AlertService.cancelAlert()) {
        this.toEditVoyageData = false;
      }

    },
    async submit() {
      swal.fire({
        'title': 'Updating Appointment Details, please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })

      swal.showLoading()

      const response = await this.updateAppointmentDetails(this.request);

      if (response.result === false) {
        swal.close();
        this.toEdit = false;
        this.toEditVoyageData = false;
        this.toEditAuditDone = false;
        return AlertService.errorAlert(response.message, 'SAVING APPOINTMENT DETAILS')
      }
      await this.getUpdatedInfo();

      //TRIGGER FOR PLAN REMARKS AND VOYAGE DATA
      const updateAppointment = {
        vessel_id: Math.random(),
        id: Math.random(),
        unique: Math.random(),
      }
      localStorage.setItem('newAppointmentAuditDue', JSON.stringify([updateAppointment]))

      this.toEdit = false;
      this.toEditVoyageData = false;
      this.toEditAuditDone = false;
      swal.close();
      AlertService.successAlert('Successfully saved data','UPDATE')
      await this.setReportTypeStatusKeys(this.selectedAuditRecord);

    },
    async getUpdatedInfo() {
      await this.getAppointmentDetailsByTypeAndId({
        id : this.selectedAuditRecord[this.$route.params.type].id,
        type : this.$route.params.type
      });
    },
    editVoyageData(){
      this.toEditVoyageData = true;
      this.voyageData = this.ia_appointment_details?.voyage_data ?? null;
    },
    editDetails() {
      this.toEdit = true;
      this.planRemarks = this.ia_appointment_details?.plan_remarks ?? null;
      this.remoteAuditReason = this.ia_appointment_details?.remote_audit_reason ?? null;
      this.auditorID = this.ia_appointment_details?.auditor?.id ?? null;
      this.isAuditDone = this.ia_appointment_details?.is_audit_done ?? 0;
      this.voyageData = this.ia_appointment_details?.voyage_data ?? null;
    },
    editAuditDone() {
      this.toEditAuditDone = true;
      this.isAuditDone = this.ia_appointment_details?.is_audit_done ?? 0;
    }
  },
  async created() {
    const userInfo = await UserService.getUser(this.user.id);
    this.is_auditor = userInfo.is_auditor;
    await this.getUpdatedInfo();
  },
  watch : {
    hasChanges() {
      this.ia_appointment_details.has_changes = this.hasChanges;
    }
  },
  computed: {
    ...mapGetters([
      'ia_appointment_details',
      'designated_persons'
    ]),
    changeDebugger() {
      return {
        plan_remarks : DataService.normalizeHtml(this.planRemarks) !== DataService.normalizeHtml(this.ia_appointment_details.plan_remarks),
        voyage_data : DataService.normalizeHtml(this.voyageData) !== DataService.normalizeHtml(this.ia_appointment_details.voyage_data),
        auditor_id : this.auditorID !== this.ia_appointment_details?.auditor_id,
        is_audit_done : this.isAuditDone !== this.ia_appointment_details?.is_audit_done,
        remote_audit_reason : DataService.normalizeHtml(this.remoteAuditReason) !== DataService.normalizeHtml(this.ia_appointment_details?.remote_audit_reason),
      }
    },
    hasChanges() {
      if (this.toEdit === false) {
        return false;
      }

      if (this.planRemarks === undefined) {
        return DataService.checkIfChanged({
          plan_remarks : this.planRemarks
        }, this.ia_appointment_details)
      }

      return DataService.normalizeHtml(this.planRemarks) !== DataService.normalizeHtml(this.ia_appointment_details.plan_remarks) ||
        DataService.normalizeHtml(this.voyageData) !== DataService.normalizeHtml(this.ia_appointment_details.voyage_data) ||
        this.auditorID !== this.ia_appointment_details?.auditor_id ||
        this.isAuditDone !== this.ia_appointment_details?.is_audit_done ||
        DataService.normalizeHtml(this.remoteAuditReason) !== DataService.normalizeHtml(this.ia_appointment_details?.remote_audit_reason);
    },
    hasAuditDoneChanges() {
      if (this.toEditAuditDone === false) {
        return false;
      }

      return this.isAuditDone !== this.ia_appointment_details?.is_audit_done;
    },
    hasVoyageDataChanges() {
      if (this.toEditVoyageData === false) {
        return false;
      }

      if (this.voyageData === undefined) {
        return DataService.checkIfChanged({
          voyage_data : this.voyageData
        }, this.ia_appointment_details)
      }

      return DataService.normalizeHtml(this.voyageData) !== DataService.normalizeHtml(this.ia_appointment_details.voyage_data)
    },
    request() {
      return {
        id : this.ia_appointment_details.id,
        plan_remarks : this.planRemarks,
        voyage_data : this.voyageData,
        auditor_id : this.auditorID,
        is_audit_done : this.isAuditDone,
        remote_audit_reason : this.remoteAuditReason,
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.hasChanges === true) {
      if (await AlertService.cancelChanges() === true) {
        next();
      }
    } else {
      next();
    }
  }
}
</script>

<style scoped lang="scss">
td {
  padding: 3px;
}
</style>
